<footer class="bg-white py-5">
	<div class="container">
		<div class="flex items-center justify-center">
			<p class="text-[13px] text-gray-400 text-center">{{ currentYear }} © <span class="text-base-100">{{ themeService.getProductName() }}</span>, <a href="/cgu" class="text-base-100">Conditions
					générales
					d'utilisation.</a></p>

			<!-- <div class="flex items-center gap-x-10">
				<a href="#" aria-label="LinkedIn">
					<i class="fab fa-linkedin-in text-xl text-[#2b3c8b] text-[14px]"></i>
				</a>
				<a href="#" aria-label="Twitter">
					<i class="fab fa-twitter text-xl text-[#2b3c8b] text-[14px]"></i>
				</a>
				<a href="#" aria-label="Facebook">
					<i class="fab fa-facebook-f text-xl text-[#2b3c8b] text-[14px]"></i>
				</a>
			</div> -->
		</div>
	</div>
</footer>